import React from "react";
import DataTableBase from "react-data-table-component";

const AppDataTable = (props) => (
  <DataTableBase
    paginationPerPage={50}
    paginationRowsPerPageOptions={[30, 50, 70, 100]}
    {...props}
  />
);

export default AppDataTable;
